module.exports = __webpack_public_path__ + "img/11.e5c31642.png";